import React from 'react';

const BellSvg = ({ color = '#7E7E7E', className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='13'
      height='14'
      viewBox='0 0 13 14'
      fill='none'
      className={className}
      {...props}
      onClick={onClick}
    >
      <path
        d='M4.25 10.6111V11.3333C4.25 11.6179 4.3082 11.8996 4.42127 12.1625C4.53435 12.4253 4.70008 12.6642 4.90901 12.8654C5.11798 13.0666 5.366 13.2262 5.63893 13.335C5.91193 13.444 6.2045 13.5 6.5 13.5C6.7955 13.5 7.08807 13.444 7.36107 13.335C7.634 13.2262 7.88202 13.0666 8.09097 12.8654C8.29992 12.6642 8.46567 12.4253 8.5787 12.1625C8.6918 11.8996 8.75 11.6179 8.75 11.3333V10.6111M11 4.83333C11 7 12.5 10.6111 12.5 10.6111H0.5C0.5 10.6111 2 7.72222 2 4.83333C2 2.47311 4.049 0.5 6.5 0.5C8.951 0.5 11 2.47311 11 4.83333Z'
        stroke={color}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default BellSvg;
